module.exports = __webpack_public_path__ + "static/media/CORP.835b7f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CORP.jpg
// module id = 1723
// module chunks = 1